import React from "react";
import { Link } from "react-router-dom";
import { useRoleVerify } from "Common/RoleVerify";
import { GetPageUrl } from "utils/CommonUtils";
import Tooltip from "Common/Custom/Tooltip";

const ViewBtn = ({ url }) => {
  const page_url = GetPageUrl();

  if (!useRoleVerify("", ["can_access"])) return null;

  return (
    <Tooltip text="View" position="top">
      <Link
        to={`/${page_url}/${url}`}
        className="btn btn-accent btn-sm border rounded-2 me-1"
        aria-label="View"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className="svg-stroke">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
          <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
        </svg>
      </Link>
    </Tooltip>
  );
};

export default ViewBtn;
